import BookingsCountLabel from 'components/Common/Labels/BookingsCountLabel'
import OfferLabels from 'components/Common/Labels/OfferLabels'
import OfferBadgeLabel from 'components/Common/OfferBadgeLabel/OfferBadgeLabel'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import type { ComponentProps } from 'react'
import React from 'react'

type InheritedOfferLabelsProps = ComponentProps<typeof OfferLabels>

interface Props extends InheritedOfferLabelsProps {
  offer: App.Offer | App.OfferSummary
  showBadge?: boolean
}

function OfferPageLabelGroup(props: Props) {
  const {
    offer,
    showBadge,
    ...offerLabelProps
  } = props

  const bookings = offer.stats.booked
  return <LabelGroup>
    <OfferLabels
      {...offerLabelProps}
      offer={offer}
      onOfferPage
    />
    <BookingsCountLabel bookings={bookings} threshold="offer" />
    {showBadge && !!offer.badge && <OfferBadgeLabel badge={offer.badge} />}
  </LabelGroup>
}

export default OfferPageLabelGroup
